<div>
    <ngx-spinner [fullScreen]="true" bdColor="rgba(0,0,0,0.2)" type="ball-spin" size="default"> </ngx-spinner>

    <mat-toolbar color="primary" class="toolbar">
        <app-back-button color="secondary" [logout]="true"></app-back-button>
    </mat-toolbar>

    <mat-card class="card">
        <mat-card-header class="header">
            <mat-card-title class="title">{{ "REGISTER.TITLE" | translate }}</mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <mat-vertical-stepper [linear]="true" #stepper class="mat-primary stepper">
                <!-- NAME -->
                <mat-step>
                    <form [formGroup]="nomeFormGroup">
                        <ng-template matStepLabel>
                            {{ "REGISTER.NAME.TITLE" | translate }}
                        </ng-template>
                        <h5>
                            {{ "REGISTER.NAME.SUBTITLE" | translate }}
                        </h5>
                        <mat-form-field class="full-width">
                            <mat-label>{{ "REGISTER.NAME.INPUTS.NAME" | translate }}</mat-label>
                            <input
                                [id]="'input_registrar_Name'"
                                matInput
                                #nome
                                maxlength="50"
                                placeholder="ex, Obi Wan"
                                formControlName="nome"
                                required
                            />
                            <mat-hint align="end"> {{ nome.value.length }} / 50 </mat-hint>
                            <mat-error *ngIf="nomeFormGroup.controls['nome'].invalid">
                                {{ "REGISTER.NAME.MESSAGES.REQUIRED" | translate }}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="full-width">
                            <mat-label>{{ "REGISTER.NAME.INPUTS.LAST_NAME" | translate }}</mat-label>
                            <input
                                [id]="'input_registrar_LastName'"
                                matInput
                                #sobrenome
                                maxlength="50"
                                placeholder="ex, Kenobi"
                                formControlName="sobrenome"
                                required
                            />
                            <mat-hint align="end"> {{ sobrenome.value.length }} / 50 </mat-hint>
                            <mat-error *ngIf="nomeFormGroup.controls['sobrenome'].invalid">
                                {{ "REGISTER.NAME.MESSAGES.REQUIRED" | translate }}
                            </mat-error>
                        </mat-form-field>
                        <div class="stepperNavButtons">
                            <button
                                [id]="'button_registrar_NomeProximo'"
                                mat-stroked-button
                                color="primary"
                                matStepperNext
                            >
                                {{ "REGISTER.NAME.ACTIONS.NEXT" | translate }}
                            </button>
                        </div>
                    </form>
                </mat-step>
                <!-- NAME -->

                <!-- EMAIL -->
                <mat-step>
                    <form [formGroup]="emailFormGroup">
                        <ng-template matStepLabel>
                            {{ "REGISTER.EMAIL.TITLE" | translate }}
                        </ng-template>
                        <h5>
                            {{ "REGISTER.EMAIL.SUBTITLE" | translate }}
                        </h5>
                        <mat-form-field class="full-width">
                            <mat-label>Email</mat-label>
                            <input
                                [id]="'input_registrar_Email'"
                                matInput
                                maxlength="60"
                                placeholder="ex, ben.kenobi@gurumatch.com"
                                formControlName="email"
                                email
                                #email
                                style="text-transform: lowercase"
                                (change)="trimEmail()"
                            />
                            <mat-hint align="end"> {{ email.value.length }} / 60 </mat-hint>
                            <mat-error *ngIf="emailFormGroup.invalid && emailFormGroup.hasError('required')">
                                {{ "REGISTER.EMAIL.MESSAGES.REQUIRED" | translate }}
                            </mat-error>
                            <mat-error *ngIf="emailFormGroup.invalid && !emailFormGroup.hasError('required')">
                                {{ "REGISTER.EMAIL.MESSAGES.INVALID" | translate }}
                            </mat-error>
                        </mat-form-field>
                        <div class="stepperNavButtons" fxLayout="row wrap" fxLayoutGap="5px">
                            <button
                                [id]="'button_registrar_EmailVoltar'"
                                mat-stroked-button
                                color="secondary"
                                matStepperPrevious
                            >
                                {{ "REGISTER.EMAIL.ACTIONS.BACK" | translate }}
                            </button>

                            <button
                                [id]="'button_registrar_EmailProximo'"
                                mat-stroked-button
                                color="primary"
                                matStepperNext
                            >
                                {{ "REGISTER.EMAIL.ACTIONS.NEXT" | translate }}
                            </button>
                        </div>
                    </form>
                </mat-step>
                <!-- EMAIL -->

                <!-- CUSTOM_FIELDS -->
                <mat-step *ngIf="showUserCustomFieldsForm" [stepControl]="appUserCustomFields.form">
                    <ng-template matStepLabel>
                        {{ "REGISTER_INVITE.USER_CUSTOM_FIELDS.TITLE" | translate }}
                    </ng-template>

                    <div fxLayout="column" fxLayoutGap="5px" class="mb-10">
                        <h5>
                            {{ "REGISTER_INVITE.USER_CUSTOM_FIELDS.SUBTITLE" | translate }}
                        </h5>
                        <!-- Skip Registration Button - Visible in all steps -->
                        <button
                            mat-stroked-button
                            color="primary"
                            *ngIf="allowSkipCompleteRegistration"
                            [disabled]="isLoading"
                            (click)="setSkipCompleteRegistration()"
                        >
                            {{ "REGISTER.DONE.ACTIONS.SKIP_REGISTRATION" | translate }}
                        </button>
                    </div>

                    <app-user-custom-fields
                        #appUserCustomFields
                        [fields]="userCustomFields$.value"
                        [user]="user"
                        [editMode]="true"
                    ></app-user-custom-fields>

                    <div class="stepperNavButtons" fxLayout="row wrap" fxLayoutGap="5px">
                        <button
                            [id]="'button_userCustomFields_Previous'"
                            mat-stroked-button
                            color="secondary"
                            matStepperPrevious
                        >
                            {{ "REGISTER_INVITE.USER_CUSTOM_FIELDS.ACTIONS.BACK" | translate }}
                        </button>

                        <button [id]="'button_userCustomFields_Next'" mat-stroked-button color="primary" matStepperNext>
                            {{ "REGISTER_INVITE.USER_CUSTOM_FIELDS.ACTIONS.NEXT" | translate }}
                        </button>
                    </div>
                </mat-step>
                <!-- CUSTOM_FIELDS -->

                <!-- CATEGORIES -->
                <mat-step *ngIf="showCategories">
                    <form fxLayout="column" fxLayoutGap="10px">
                        <ng-template matStepLabel>
                            {{ "REGISTER.CATEGORIES.TITLE" | translate }}
                        </ng-template>

                        <div fxLayout="column" fxLayoutGap="5px" class="mb-10">
                            <h5>
                                {{ "REGISTER.CATEGORIES.SUBTITLE" | translate }}
                            </h5>
                            <!-- Skip Registration Button - Visible in all steps -->
                            <button
                                mat-stroked-button
                                color="primary"
                                *ngIf="allowSkipCompleteRegistration"
                                [disabled]="isLoading"
                                (click)="setSkipCompleteRegistration()"
                            >
                                {{ "REGISTER.DONE.ACTIONS.SKIP_REGISTRATION" | translate }}
                            </button>
                        </div>

                        <mat-chip-list [multiple]="true">
                            <mat-chip
                                *ngFor="let tag of tags"
                                (click)="selectMainTag(tag.id)"
                                [selected]="tag.selected"
                            >
                                {{ tag.nome }}
                            </mat-chip>
                        </mat-chip-list>

                        <mat-chip-list *ngFor="let tag of getSelectedTags()" style="margin-top: 25px" [multiple]="true">
                            <b style="width: 100%; text-align: center">
                                {{ tag.nome }}
                            </b>

                            <mat-chip
                                *ngFor="let child of tag.subCategorias"
                                (click)="selectChildrenTag(tag.id, child.id)"
                                [selected]="child.selected"
                                style="margin-top: 10px; margin-bottom: 15px"
                            >
                                {{ child.nome }}
                            </mat-chip>
                        </mat-chip-list>

                        <div class="stepperNavButtons" fxLayout="row wrap" fxLayoutGap="5px">
                            <button
                                [id]="'button_registrar_CategoriasVoltar'"
                                mat-stroked-button
                                color="secondary"
                                matStepperPrevious
                            >
                                {{ "REGISTER.CATEGORIES.ACTIONS.BACK" | translate }}
                            </button>

                            <button
                                [id]="'button_registrar_CategoriasProximo'"
                                mat-stroked-button
                                color="primary"
                                matStepperNext
                            >
                                {{ "REGISTER.CATEGORIES.ACTIONS.NEXT" | translate }}
                            </button>
                        </div>
                    </form>
                </mat-step>
                <!-- CATEGORIES -->

                <!-- TERMS_OF_USE -->
                <mat-step *ngIf="subscription?.features?.termsOfUse?.active == true" [stepControl]="termosUsoFormGroup">
                    <form [formGroup]="termosUsoFormGroup">
                        <ng-template matStepLabel>
                            {{ "REGISTER.TERMS_OF_USE.TITLE" | translate }}
                        </ng-template>

                        <button [id]="'button_ReadTerms'" mat-stroked-button (click)="openTermsOfUseDialog()">
                            {{ "REGISTER.TERMS_OF_USE.SUBTITLE" | translate }}
                            <mat-icon>visibility</mat-icon>
                        </button>

                        <mat-slide-toggle
                            [id]="'toggle_isTermsRead'"
                            (change)="onChange($event, stepper)"
                            #toggleTermosUso
                            color="primary"
                            formControlName="aceitoTermos"
                            style="margin-top: 25px; display: flex; float: right"
                            [disabled]="!TermsOfUseClicked"
                        >
                            {{ "REGISTER.TERMS_OF_USE.INPUTS.TOGGLE" | translate }}
                        </mat-slide-toggle>
                    </form>
                </mat-step>
                <!-- TERMS_OF_USE -->

                <!-- PRIVACY_POLICY -->
                <mat-step
                    *ngIf="subscription?.features?.privacyPolicy?.active == true"
                    [stepControl]="politicaPrivacidadeFormGroup"
                >
                    <form [formGroup]="politicaPrivacidadeFormGroup">
                        <ng-template matStepLabel>
                            {{ "REGISTER.PRIVACY_POLICY.TITLE" | translate }}
                        </ng-template>

                        <button [id]="'button_ReadPrivacy'" mat-stroked-button (click)="openPrivacyPoliceDialog()">
                            {{ "REGISTER.PRIVACY_POLICY.SUBTITLE" | translate }}
                            <mat-icon>visibility</mat-icon>
                        </button>

                        <mat-slide-toggle
                            [id]="'toggle_isPrivacyRead'"
                            (change)="onChange($event, stepper)"
                            #togglePoliticaPrivacida
                            color="primary"
                            formControlName="concordoPoliticaPrivacidade"
                            style="margin-top: 25px; display: flex; float: right"
                            [disabled]="!privacyPolicyClicked"
                        >
                            {{ "REGISTER.PRIVACY_POLICY.INPUTS.TOGGLE" | translate }}
                        </mat-slide-toggle>
                    </form>
                </mat-step>
                <!-- PRIVACY_POLICY -->

                <!-- SAVE_BUTTON -->
                <mat-step>
                    <ng-template matStepLabel>
                        {{ "REGISTER.DONE.TITLE" | translate }}
                    </ng-template>
                    <h5>
                        {{ "REGISTER.DONE.SUBTITLE" | translate }}
                    </h5>

                    <div [hidden]="!error" class="alert alert-warning">
                        {{ error }}
                    </div>
                    <div [hidden]="!errorApi" class="alert alert-warning">
                        {{ errorApi | json }}
                    </div>

                    <div [hidden]="!success" class="alert alert-info">
                        {{ success }}
                    </div>

                    <div class="stepperNavButtons" fxLayout="row wrap" fxLayoutGap="5px">
                        <button
                            [id]="'button_registrar_FeitoVoltar'"
                            mat-stroked-button
                            color="secondary"
                            matStepperPrevious
                        >
                            {{ "REGISTER.DONE.ACTIONS.BACK" | translate }}
                        </button>

                        <button
                            [id]="'button_registrar_FeitoCadastrar'"
                            mat-flat-button
                            color="primary"
                            (click)="save()"
                            [disabled]="
                                isLoading ||
                                (subscription?.features?.privacyPolicy?.active == true &&
                                    !termosUsoFormGroup?.controls?.aceitoTermos?.value)
                            "
                            [class.spinner]="isLoading"
                        >
                            {{ "REGISTER.DONE.ACTIONS.REGISTER" | translate }}
                        </button>
                    </div>
                </mat-step>
                <!-- SAVE_BUTTON -->
            </mat-vertical-stepper>

            <!-- Skip Registration Button - Visible in all steps -->
            <!-- <div *ngIf="allowSkipCompleteRegistration" class="skip-registration-container">
                <button mat-button color="primary" [disabled]="isLoading" (click)="save(true)">
                    {{ "REGISTER.DONE.ACTIONS.SKIP_REGISTRATION" | translate }}
                </button>
            </div> -->
        </mat-card-content>
    </mat-card>
</div>
